const EDIT_LOCK_STORAGE_KEY = 'gx_dashboard_edit_lock_holder';

type StoredDashboardEditLock = {
  tabId: string;
};

const isStoredDashboardEditLock = (value: unknown): value is StoredDashboardEditLock =>
  typeof value === 'object' &&
  value !== null &&
  'tabId' in value &&
  typeof value.tabId === 'string';

export const getStoredDashboardEditLockHolder = (): string | null => {
  try {
    const rawValue = localStorage.getItem(EDIT_LOCK_STORAGE_KEY);
    if (!rawValue) return null;

    const parsedValue: unknown = JSON.parse(rawValue);
    if (!isStoredDashboardEditLock(parsedValue)) {
      localStorage.removeItem(EDIT_LOCK_STORAGE_KEY);
      return null;
    }

    return parsedValue.tabId;
  } catch {
    return null;
  }
};

export const setStoredDashboardEditLockHolder = (tabId: string): void => {
  try {
    localStorage.setItem(EDIT_LOCK_STORAGE_KEY, JSON.stringify({ tabId }));
  } catch {
    // Ignore storage failures; BroadcastChannel still keeps active tabs in sync.
  }
};

export const clearStoredDashboardEditLockHolder = (tabId?: string): void => {
  try {
    if (tabId && getStoredDashboardEditLockHolder() !== tabId) return;
    localStorage.removeItem(EDIT_LOCK_STORAGE_KEY);
  } catch {
    // Ignore storage failures; the in-memory holder is cleared by callers.
  }
};
